import {
  React,
  useState,
  useEffect,
  useRef,
  useImperativeHandle,
  forwardRef
} from 'react'
import { Checkbox, Divider, Grid } from '@mui/material'

import { FormControlLabel, FormGroup } from '@mui/material'
import { TextBold, TextRegular, TextSemiBold } from './TextStyling'
import { useTheme } from '@mui/styles'

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import AppButton from './AppButton'

const FilterComponent = forwardRef(({ dropDown, onFilterChange }, ref) => {
  const [visibleItems, setVisibleItems] = useState(5)
  const [isViewMore, setIsViewMore] = useState(true)

  const [visibleIndustry, setVisibleIndustry] = useState(5)
  const [isViewMoreIndustry, setIsViewMoreIndustry] = useState(true)

  const theme = useTheme()
  const [open, setOpen] = useState({
    jobType: false,
    workLocation: false,
    jobFunction: false,
    industry: false,
    location: false,
    referralReward: false
  })
  const isInitialMount = useRef(true) // Ref to track initial render

  const [checkedJobType, setCheckedJobType] = useState([])
  const [checkedWorkLocation, setCheckedWorkLocation] = useState([])
  const [checkedLocation, setCheckedLocation] = useState([])
  const [checkedJobFunction, setCheckedJobFunction] = useState([])
  const [checkedIndustry, setCheckedIndustry] = useState([])
  const [checkedReferralReward, setCheckedReferralReward] = useState([])

  useImperativeHandle(ref, () => ({
    updateFunctionalRoles (data) {
      setCheckedJobFunction(data)
    }
  }))

  const handleCheckBoxChange = (category, item) => {
    var data
    switch (category) {
      case 'jobType':
        data = updateCheckedArray(checkedJobType, item)
        setCheckedJobType(data)
        break
      case 'workLocation':
        data = updateCheckedArray(checkedWorkLocation, item)
        setCheckedWorkLocation(data)
        break
      case 'industry':
        data = updateCheckedArray(checkedIndustry, item)
        setCheckedIndustry(data)
        break
      case 'jobFunction':
        data = updateCheckedArray(checkedJobFunction, item)
        setCheckedJobFunction(data)
        break
      case 'referralReward':
        data = updateCheckedArray(checkedReferralReward, item)
        setCheckedReferralReward(data)
        break

      default:
        break
    }
  }

  const updateCheckedArray = (array, item) => {
    const index = array.findIndex(e => e === item.id)
    const newArray = [...array]
    if (index === -1) {
      newArray.push(item.id)
    } else {
      newArray.splice(index, 1)
    }
    return newArray
  }

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false
    } else {
      onFilterChange({
        jobTypes: checkedJobType.length > 0 ? checkedJobType : null,
        workLocationType:
          checkedWorkLocation.length > 0 ? checkedWorkLocation : null,
        jobFunction: checkedJobFunction.length > 0 ? checkedJobFunction : null,
        jobIndustry: checkedIndustry.length > 0 ? checkedIndustry : null,
        referralReward:
          checkedReferralReward.length > 0 ? checkedReferralReward : null
        // location: {},
      })
    }
  }, [
    checkedJobType,
    checkedJobFunction,
    checkedIndustry,
    checkedWorkLocation,
    checkedReferralReward
  ])

  const handleOpen = field => {
    setOpen(prevState => ({
      ...prevState,
      [field]: !prevState[field]
    }))
  }

  return (
    <Grid
      container
      style={{
        height: 'min-content',
        maxHeight: '100%',
        borderRadius: '16px',
        backgroundColor: theme.palette.background.paper,
        overflowY: 'auto'
      }}
    >
      <Grid
        item
        xs={12}
        style={{
          display: 'flex',
          flexDirection: 'column',
          margin: '24px'
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}
        >
          <TextBold style={{ fontSize: '16px' }}>All Filters</TextBold>

          <TextRegular
            onClick={() => {
              setCheckedJobType([])
              setCheckedWorkLocation([])
              setCheckedLocation([])
              setCheckedIndustry([])
              setCheckedJobFunction([])
              setCheckedReferralReward([])
              setOpen({
                jobType: false,
                workLocation: false,
                jobFunction: false,
                industry: false,
                location: false,
                referralReward: false
              })
            }}
            style={{ color: theme.palette.text.disabled, cursor: 'pointer' }}
          >
            Clear All
          </TextRegular>
        </div>

        <Divider
          style={{
            margin: '16px 0px'
          }}
        />
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              cursor: 'pointer',
              alignItems: 'center'
            }}
            onClick={() => handleOpen('jobType')}
          >
            <TextSemiBold
              style={{ fontSize: '16px', lineHeight: '24px', flexGrow: 1 }}
            >
              Job Type
            </TextSemiBold>
            <div style={{ display: 'flex', margin: '0px' }}>
              {open?.jobType ? (
                <KeyboardArrowUpIcon style={{ fontSize: '20px' }} />
              ) : (
                <KeyboardArrowDownIcon style={{ fontSize: '20px' }} />
              )}
            </div>
          </div>
          {open.jobType ? (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <FormGroup>
                {dropDown?.jobTypes?.map(item => (
                  <FormControlLabel
                    key={item.id}
                    label={
                      <span style={{ fontSize: '14px' }}>{item.name}</span>
                    }
                    control={
                      <Checkbox
                        name={item.id}
                        checked={checkedJobType.includes(item.id)}
                        onChange={() => handleCheckBoxChange('jobType', item)}
                      />
                    }
                  />
                ))}
              </FormGroup>
            </div>
          ) : (
            <></>
          )}
        </div>
        <Divider
          style={{
            margin: '16px 0px'
          }}
        />

        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              cursor: 'pointer',
              alignItems: 'center'
            }}
            onClick={() => handleOpen('workLocation')}
          >
            <TextSemiBold
              style={{ fontSize: '16px', lineHeight: '24px', flexGrow: 1 }}
            >
              Work Location
            </TextSemiBold>
            <div style={{ display: 'flex', margin: '0px' }}>
              {open?.workLocation ? (
                <KeyboardArrowUpIcon style={{ fontSize: '20px' }} />
              ) : (
                <KeyboardArrowDownIcon style={{ fontSize: '20px' }} />
              )}
            </div>
          </div>
          {open.workLocation ? (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <FormGroup>
                {dropDown?.workLocationTypes?.map(item => (
                  <FormControlLabel
                    key={item.id}
                    label={
                      <span style={{ fontSize: '14px' }}>{item.name}</span>
                    }
                    control={
                      <Checkbox
                        name={item.id}
                        checked={checkedWorkLocation.includes(item.id)}
                        onChange={() =>
                          handleCheckBoxChange('workLocation', item)
                        }
                      />
                    }
                  />
                ))}
              </FormGroup>
            </div>
          ) : (
            <></>
          )}
        </div>
        <Divider
          style={{
            margin: '16px 0px'
          }}
        />

        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div
            style={{ display: 'flex', flexDirection: 'row', cursor: 'pointer' }}
            onClick={() => handleOpen('jobFunction')}
          >
            <TextSemiBold
              style={{ fontSize: '16px', lineHeight: '24px', flexGrow: 1 }}
            >
              Job Function
            </TextSemiBold>
            <div style={{ display: 'flex', margin: '0px' }}>
              {open?.jobFunction ? (
                <KeyboardArrowUpIcon style={{ fontSize: '20px' }} />
              ) : (
                <KeyboardArrowDownIcon style={{ fontSize: '20px' }} />
              )}
            </div>
          </div>
          {open.jobFunction ? (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <FormGroup>
                {dropDown?.jobFunctions?.slice(0, visibleItems).map(item => (
                  <FormControlLabel
                    key={item.id}
                    label={
                      <span style={{ fontSize: '14px' }}>{item.name}</span>
                    }
                    control={
                      <Checkbox
                        name={item.id}
                        checked={checkedJobFunction.includes(item.id)}
                        onChange={() =>
                          handleCheckBoxChange('jobFunction', item)
                        }
                      />
                    }
                  />
                ))}
                {dropDown?.jobFunctions?.length > 5 && (
                  <AppButton
                    onClick={() => {
                      if (isViewMore) {
                        setVisibleItems(dropDown?.jobFunctions?.length)
                      } else {
                        setVisibleItems(5)
                      }
                      setIsViewMore(!isViewMore)
                    }}
                    variant='text'
                    name={isViewMore ? 'View more' : 'View less'}
                    style={{
                      fontSize: '14px',
                      display: 'flex',
                      justifyContent: 'left',
                      fontWeight: 600
                    }}
                  />
                )}
              </FormGroup>
            </div>
          ) : (
            <></>
          )}
        </div>

        <Divider
          style={{
            margin: '16px 0px'
          }}
        />
        <div
          style={{
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              cursor: 'pointer',
              alignItems: 'center',
              marginBottom: 8
            }}
            onClick={() => handleOpen('industry')}
          >
            <TextSemiBold style={{ fontSize: '16px', flexGrow: 1 }}>
              Industry
            </TextSemiBold>
            {open?.industry ? (
              <KeyboardArrowUpIcon style={{ fontSize: '20px' }} />
            ) : (
              <KeyboardArrowDownIcon style={{ fontSize: '20px' }} />
            )}
          </div>
          {open.industry ? (
            <FormGroup>
              {dropDown?.industries?.slice(0, visibleIndustry).map(item => (
                <FormControlLabel
                  style={{
                    margin: 0,
                    paddingBottom: 16
                  }}
                  key={item.id}
                  label={
                    <span style={{ fontSize: '14px', marginLeft: 10 }}>
                      {item.name}
                    </span>
                  }
                  control={
                    <Checkbox
                      style={{ padding: 0 }}
                      name={item.id}
                      checked={checkedIndustry.includes(item.id)}
                      onChange={() => handleCheckBoxChange('industry', item)}
                    />
                  }
                />
              ))}
              {dropDown?.industries?.length > 5 && (
                <AppButton
                  onClick={() => {
                    if (isViewMoreIndustry) {
                      setVisibleIndustry(dropDown?.industries?.length)
                    } else {
                      setVisibleIndustry(5)
                    }
                    setIsViewMoreIndustry(!isViewMoreIndustry)
                  }}
                  variant='text'
                  name={isViewMoreIndustry ? 'View more' : 'View less'}
                  style={{
                    fontSize: '14px',
                    display: 'flex',
                    justifyContent: 'left',
                    fontWeight: 600
                  }}
                />
              )}
            </FormGroup>
          ) : (
            <></>
          )}
        </div>
        <Divider
          style={{
            margin: '16px 0px'
          }}
        />
        {/* to-do drop down location and referral by API */}
        {/* <div style={{ display: "flex", flexDirection: "column" }}>
          <div
            style={{ display: "flex", flexDirection: "row", cursor: "pointer" }}
            onClick={() => handleOpen("location")}
          >
            <div style={{ display: "flex", margin: "10px 5px 0px 0px" }}>
              <AddIcon style={{ fontSize: "14px" }} />
            </div>
            <div>Location</div>
          </div>
          
        </div>
        <Divider style={{
            margin: '16px 0px'
          }}/> */}
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              cursor: 'pointer',
              alignItems: 'center'
            }}
            onClick={() => handleOpen('referralReward')}
          >
            <TextSemiBold
              style={{ fontSize: '16px', lineHeight: '24px', flexGrow: 1 }}
            >
              Referral Reward
            </TextSemiBold>
            {open?.referralReward ? (
              <KeyboardArrowUpIcon style={{ fontSize: '20px' }} />
            ) : (
              <KeyboardArrowDownIcon style={{ fontSize: '20px' }} />
            )}
          </div>
          {open.referralReward ? (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <FormGroup>
                {[
                  { id: 'fixed', name: 'Fixed' },
                  { id: 'percentage', name: 'Percentage' },
                  { id: 'hourly', name: 'Hourly' }
                ].map(item => (
                  <FormControlLabel
                    key={item.id}
                    label={
                      <span style={{ fontSize: '14px' }}>{item.name}</span>
                    }
                    control={
                      <Checkbox
                        name={item}
                        checked={checkedReferralReward.includes(item.id)}
                        onChange={() =>
                          handleCheckBoxChange('referralReward', item)
                        }
                      />
                    }
                  />
                ))}
              </FormGroup>
            </div>
          ) : (
            <></>
          )}
        </div>
      </Grid>
    </Grid>
  )
})

export default FilterComponent
